import React from "react";
import { Container } from "react-bootstrap";
import "./rewardmanagement.css";

const GuestExperience = () => {
  return (
    <Container className="py-5 reward-management">
      <h2 className="section-title">Hotel Guest Experience with Cloud10</h2>
      <p className="lead">
        Cloud10 transforms the hospitality journey into a seamless, efficient,
        and contactless experience from booking to checkout. By leveraging smart
        automation, digital keys, and guest verification systems, hotels can
        enhance satisfaction and streamline operations at every step.
      </p>

      <h4 className="subheading">🚀 Key Features:</h4>
      <ul className="feature-list">
        <li>
          <strong>✅ Guest Verification After Hotel Booking:</strong>
          Cloud10’s platform enables guests to verify their data within a set
          timeframe after booking. This streamlines the pre-arrival process,
          reduces friction, and ensures hotels receive accurate guest profiles
          for faster check-ins and personalized service.
        </li>
        <li>
          <strong>🔐 Seamless Contactless Guest Experience:</strong>
          Guests can access their rooms using digital keys. The entire stay—from
          check-in to service requests—is powered by automation, eliminating
          delays and enhancing convenience.
        </li>
        <li>
          <strong>📤 Automated Checkout and Loyalty Integration:</strong>
          Guests enjoy a smooth checkout process with digital receipts and
          automatic loyalty program enrolment. Every guest interaction is
          captured and analyzed to personalize future stays and build stronger
          relationships.
        </li>
      </ul>

      <h4 className="subheading mt-5">🎯 Strategic Benefits:</h4>
      <ul className="feature-list">
        <li>
          <strong>Improve Operational Efficiency</strong> by automating routine
          guest touchpoints and reducing manual check-in/load.
        </li>
        <li>
          <strong>Enhance Guest Satisfaction</strong> through faster,
          contactless, and personalized services from arrival to departure.
        </li>
        <li>
          <strong>Boost Loyalty & Retention</strong> with integrated enrolment
          systems and data-driven guest personalization.
        </li>
        <li>
          <strong>Enable Data-Driven Improvements</strong> by capturing and
          analyzing all guest interactions to refine services.
        </li>
      </ul>
    </Container>
  );
};

export default GuestExperience;
